import { useState } from "react";
import styles from "./Notification.module.css";
import Modals from "../Modals/Modals";
import DialogDelete from "../../hooks/DialogDelete";

const Notification = (props) => {
  //======= Delete dialog ===== //
  const [openDialog, setOpenDialog] = useState(true);
  const handleOpenDelete = () => {
    setOpenDialog(true);
  };
  const handleCloseDeleteDialog = () => {
    setOpenDialog(false);
  };
  //======= Delete dialog ===== //

  return (
    <div className={styles.parentContainer}>
      <DialogDelete
        openDialog={props?.showNotification}
        handleCloseDialog={(e) => props.setShowNotification(false)}
        title="Upcoming Session ⏰"
        // body={<div style={{fontSize:"16px", fontWeight:"500", color:"#33415C", lineHeight:"24px"}}><span style={{fontWeight:"300"}}>Live session starts in 15 mins (10:00 am) - </span>Introduction to <br/>Islamic Economics and Finance</div>}
        body={<div style={{fontSize:"16px", fontWeight:"500", color:"#33415C", lineHeight:"24px"}}><span style={{fontWeight:"300"}}>{props?.message?.split("-")[0]?.trim()} - </span>{props?.message?.split("-")[1]?.trim()}</div>}
        ModalFooter={true}
        Width="552px"
        actionButton="View"
        cancelButton="Close"
        ButtonBackground="#004FE0"
        ButtonLavelColor="#fff"
        CloseIcon={true}
        handleConfirmCloseDialog={() => console.log("view clicked")}
      />


      <DialogDelete
        openDialog={false}
        handleCloseDialog={handleCloseDeleteDialog}
        title="New Announcement 📢"
        body={<div style={{fontSize:"16px", fontWeight:"500", color:"#33415C", lineHeight:"24px"}}><span style={{fontWeight:"300"}}>New announcement in </span>Introduction to Islamic Economics and Finance</div>}
        ModalFooter={true}
        Width="552px"
        actionButton="View"
        cancelButton="Close"
        ButtonBackground="#004FE0"
        ButtonLavelColor="#fff"
        CloseIcon={true}
      />

    </div>
  );
};

export default Notification;
